// Footer (plan 8.2.2): ● collection server connected · last record n min ago (GET /api/v1/status: server-wide for
// system.view, otherwise my own last record) · stored in UTC, shown in Korea time · "기록 없음 ≠ 안 씀" (fixed, 9.1.6).
import { useFooterStatus } from '../api/shell';
import { useFmt, useT } from '../i18n';
import { Icon } from '../ui/Icon';

export function Footer() {
  const t = useT();
  const fmt = useFmt();
  const status = useFooterStatus();
  const online = status.isSuccess && status.data.collectorConnected;
  const known = status.isSuccess || status.isError;
  const last = status.data?.lastRecordAt ?? null;
  return (
    <footer className="app-footer">
      {known ? (
        <span className="app-footer__item">
          <span className={'status-dot ' + (online ? 'status-dot--online' : 'status-dot--offline')} aria-hidden="true" />
          {t(online ? 'status.online' : 'status.offline')}
        </span>
      ) : null}
      {last ? <span className="app-footer__item">{t('footer.last', { rel: fmt.rel(last) })}</span> : null}
      <span className="app-footer__item">
        <Icon name="globe" />
        {t('footer.tz')}
      </span>
      <span className="app-footer__item app-footer__norec">
        <Icon name="info" />
        {t('footer.noRecord')}
      </span>
    </footer>
  );
}
